export default __webpack_public_path__ + "4a18aeffe8b8798c339a84314a8f6c5e.png";